$(function () {
  'use strict';

  $('.clear-compare').click(function (e) {
    e.preventDefault();
    clearCompare($(this).data('savetype'), $(this).data('saveparam'));
  });

  if (typeof $('.trigger-compare') !== "undefined" && $('.trigger-compare').length > 0) {
    var loadCompareQMI = JSON.parse(localStorage.getItem('saveCompareHomes'));
    var loadCompareCommunities = JSON.parse(localStorage.getItem('saveCompareCommunities'));
    var loadCompareFloor = JSON.parse(localStorage.getItem('saveCompareFloor'));
    var loadCompareSaved = Array.prototype.concat.apply([], [loadCompareQMI, loadCompareCommunities, loadCompareFloor]);

    $('.trigger-compare').each(function () {
      var trigger = $(this);
      var icon = trigger.find('i');
      var saveId = trigger.data('saveid');

      // Display check if saved for compare, empty box if not
      var matchId = _.find(loadCompareSaved, ['saveId', saveId]);
      if (matchId && icon.hasClass('fa-square-o')) {
        icon.swapClass('fa-check-square', 'fa-square-o');
      } else if (!matchId && icon.hasClass('fa-check-square')) {
        icon.swapClass('fa-square-o', 'fa-check-square');
      }
    });
  }

  $('.floorplan-save, .qmi-save').on('click tap', function (e) {
    e.preventDefault();
    var saveType = $(this).data('savetype');
    var saveId = $(this).data('saveid');
    var comparePath = $(this).data('comparepath');
    var arrayName;
    var numSaved = 0;

    if (saveType === 'floor') {
      arrayName = 'saveCompareFloor';
    } else if (saveType === 'qmi') {
      arrayName = 'saveCompareHomes';
    }

    var newCompareSaved = {
      'saveId': saveId,
      'saveType': saveType
    };

    if (typeof localStorage.getItem(arrayName) === "undefined" || localStorage.getItem(arrayName) === null) {
      localStorage.setItem(arrayName, JSON.stringify([newCompareSaved]));
      numSaved = 1;
    }

    var compareSaved = JSON.parse(localStorage.getItem(arrayName));
    if (!(compareSaved instanceof Array)) {
      compareSaved = [compareSaved];
    }
    if (compareSaved.length < 3) {
      var getSaved = _.find(compareSaved, {
        'saveId': saveId
      });

      var compareSavedType = _.filter(compareSaved, function (item) {
        return item.saveType === saveType;
      });

      if ((getSaved === null || typeof getSaved === "undefined") && compareSavedType.length < 3) {
        compareSaved.push(newCompareSaved);
        compareSavedType = _.filter(compareSaved, function (item) {
          return item.saveType === saveType;
        });
      }
      // save to localStorage
      localStorage.setItem(arrayName, JSON.stringify(compareSaved));
      numSaved = compareSavedType.length;
    }

    var compareObject = JSON.parse(localStorage.getItem(arrayName));

    // Get IDs that match the last selected saveType
    var compareIDs = _.filter(compareObject, function (item) {
      return item.saveType === saveType;
    }).map(function (e) {
      return e.saveId;
    }).join(',');

    var url = comparePath + '?IDs=' + compareIDs + '&saveType=' + saveType;
    window.location.href = url;
  });

  /* Handle saving of items */
  $('.trigger-save').on('click tap', function (e) {
    e.preventDefault();
    var trigger = $(this);
    var saveType = $(this).data('savetype');
    var saveId = $(this).data('saveid');

    if (saveType && saveId) {
      if ($(this).find('i').hasClass('fa-heart-o')) {
        // * Not selected when clicked, so we want to add it to our list
        triggerSave(saveId, saveType, 'add');
      } else {
        // * Already selected when clicked, so we want to remove from our list
        triggerSave(saveId, saveType, 'remove');
      }
    }
    trigger.find('i').swapClass('fa-heart', 'fa-heart-o');
  });

  // * Handle comparing of items
  $('.trigger-compare').on('click tap', function (e) {
    e.preventDefault();
    var trigger = $(this);
    var modal = $('#' + $(this).data('toggle'));
    var saveType = $(this).data('savetype');
    var manualSaveType = $(this).data('savetypelong');
    var saveId = $(this).data('saveid');
    var comparePath = $(this).data('comparepath');
    var arrayName;

    // * Add close handler to tooltip modal area for iOS bug
    modal.on('click tap', function () {
      trigger.foundation('hide');
    });

    // * Save types dictionary
    var saveTypes = {
      'comm': 'communities',
      'qmi': 'homes',
      'floor': 'floorplans'
    };

    function arrayType(type) {
      if (type === 'communities') {
        arrayName = 'saveCompareCommunities';
      } else if (type === 'homes') {
        arrayName = 'saveCompareHomes';
      } else if (type === 'floorplans') {
        arrayName = 'saveCompareFloor';
      }
    }


    if ($(this).find('i').hasClass('fa-square-o')) {
      // * Not selected when clicked, so we want to add it to our list
      var saveTypeLong = (typeof manualSaveType !== "undefined" && manualSaveType.length > 0) ? manualSaveType : saveTypes[saveType];
      arrayType(saveTypes[saveType]);
      if (saveType && saveId) {
        saveCompare(arrayName, saveId, saveType, saveTypeLong, modal, trigger, comparePath);
        trigger.foundation('show');
      }
    } else {
      // * Already selected when clicked, so we want to remove from our list
      arrayType(saveTypes[saveType]);
      trigger.foundation('hide');
      removeCompare(arrayName, saveId, saveType, modal);
      trigger.find('i').swapClass('fa-check-square', 'fa-square-o');
    }
  });

  function setModalText(e, text, buttonText, buttonUrl) {
    if (buttonText && buttonUrl) {
      text += '<a href="' + buttonUrl + '" class="button">' + buttonText + '</a>';
    }
    e.find('p').html(text);
  }

  function saveCompare(arrayName, saveId, saveType, saveTypeLong, modal, trigger, comparePath) {
    var numSaved = 0;

    // get the new saved data
    var newCompareSaved = {
      'saveId': saveId,
      'saveType': saveType
    };

    var compareObject = JSON.parse(localStorage.getItem(arrayName));

    var compareIDs = _.filter(compareObject, function (item) {
      return item.saveType === saveType;
    }).map(function (e) {
      return e.saveId;
    }).join(',');

    var url = comparePath + '?IDs=' + compareIDs + '&saveType=' + saveType;

    // check if any current selected compare selections exist
    if (typeof localStorage.getItem(arrayName) === "undefined" || localStorage.getItem(arrayName) === null) {
      localStorage.setItem(arrayName, JSON.stringify([newCompareSaved]));
      numSaved = 1;
    } else {
      var compareSaved = JSON.parse(localStorage.getItem(arrayName));
      // if current data is not an array, convert to array (edge case)
      if (!(compareSaved instanceof Array)) {
        compareSaved = [compareSaved];
      }
      if (compareSaved.length >= 3) {
        setModalText(modal, 'You\'ve already selected 3 of 3 ' + saveTypeLong + '. Please remove one or more before adding another.', 'View ' + saveTypeLong, url);
        return;
      }

      // check if compare item exists
      var getSaved = _.find(compareSaved, {
        'saveId': saveId
      });

      var compareSavedType = _.filter(compareSaved, function (item) {
        return item.saveType === saveType;
      });

      if ((getSaved === null || typeof getSaved === "undefined") && compareSavedType.length < 3) {
        compareSaved.push(newCompareSaved);
        compareSavedType = _.filter(compareSaved, function (item) {
          return item.saveType === saveType;
        });
      }
      // save to localStorage
      localStorage.setItem(arrayName, JSON.stringify(compareSaved));
      numSaved = compareSavedType.length;
    }

    if (numSaved > 0) {
      compareObject = JSON.parse(localStorage.getItem(arrayName));

      // Get IDs that match the last selected saveType
      compareIDs = _.filter(compareObject, function (item) {
        return item.saveType === saveType;
      }).map(function (e) {
        return e.saveId;
      }).join(',');

      url = comparePath + '?IDs=' + compareIDs + '&saveType=' + saveType;

      if (numSaved === 1) {
        setModalText(modal, 'You\'ve selected 1 of 3 ' + saveTypeLong + '. Please choose one or two more to compare.');
        trigger.find('i').swapClass('fa-check-square', 'fa-square-o');
      } else if (numSaved === 2 || numSaved === 3) {
        setModalText(modal, 'You\'ve selected ' + numSaved + ' of 3 ' + saveTypeLong + '.', 'View ' + saveTypeLong, url);
        trigger.find('i').swapClass('fa-check-square', 'fa-square-o');
      }
    } else {
      setModalText(modal, 'Something went wrong while trying to add this to your ' + saveTypeLong + ' compare list.  Please try again later.');
    }
  }

  function removeCompare(arrayName, saveId) {
    var compareSaved = localStorage.getItem(arrayName);
    if (typeof compareSaved !== "undefined" && compareSaved !== null && compareSaved.length > 0) {
      compareSaved = JSON.parse(compareSaved);

      // check if selection exists
      var getSaved = _.find(compareSaved, {
        'saveId': saveId
      });
      if (typeof getSaved !== "undefined") {
        // remove matched item using filtering
        compareSaved = compareSaved.filter(function (item) {
          return item.saveId !== saveId;
        });

        // update localStorage item with filtered data
        localStorage.setItem(arrayName, JSON.stringify(compareSaved));
      }
    }

    // remove localStorage item if empty value
    if (typeof compareSaved !== "undefined" && compareSaved !== null && compareSaved.length < 1) {
      localStorage.removeItem(arrayName);
    }
  }

  function clearCompare(arrayName, saveType, param) {
    var compareSaved = localStorage.getItem(arrayName);
    var clearSaved;
    if (typeof compareSaved !== "undefined" && compareSaved !== null && compareSaved.length > 0) {
      compareSaved = JSON.parse(compareSaved);

      // check if selection exists
      clearSaved = _.filter(compareSaved, function (item) {
        return item.saveType !== saveType;
      });

      // update localStorage item with filtered data
      localStorage.setItem(arrayName, JSON.stringify(clearSaved));
    }
    // remove localStorage item if empty value
    if (typeof clearSaved !== "undefined" && clearSaved !== null && clearSaved.length < 1) {
      localStorage.removeItem(arrayName);
    }

    setTimeout(function () {
      window.location.href = removeURLParameter(window.location.href, param);
    }, 100);
  }

  function removeURLParameter(url, parameter) {
    //prefer to use l.search if you have a location/link object
    var urlparts = url.split('?');
    if (urlparts.length >= 2) {

      var prefix = encodeURIComponent(parameter) + '=';
      var pars = urlparts[1].split(/[&;]/g);

      //reverse iteration as may be destructive
      for (var i = pars.length; i-- > 0;) {
        //idiom for string.startsWith
        if (pars[i].lastIndexOf(prefix, 0) !== -1) {
          pars.splice(i, 1);
        }
      }

      url = urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : "");
      return url;
    } else {
      return url;
    }
  }

  function triggerSave(saveId, saveType, action) {
    var saved = JSON.parse(localStorage.getItem('save'));
    var newSaved = {
      'saveId': saveId,
      'saveType': saveType
    };

    if (action === 'remove') {
      if (typeof saved !== "undefined" && saved !== null && saved.length > 0) {
        saved = saved.filter(function (item) {
          return item.saveId !== saveId;
        });

        if (saved === null || saved.length < 1) {
          localStorage.removeItem('save');
        } else {
          localStorage.setItem('save', JSON.stringify(saved));
        }
      }
    } else {
      if (typeof saved !== "undefined" && saved !== null) {
        // if current data is not an array, convert to array (edge case)
        if (!(saved instanceof Array)) {
          saved = [saved];
        }

        var getSaved = _.find(saved, {
          'saveId': saveId
        });
        if (getSaved === null || typeof getSaved === "undefined") {
          saved.push(newSaved);
          localStorage.setItem('save', JSON.stringify(saved));
        }
      } else {
        saved = [newSaved];
        localStorage.setItem('save', JSON.stringify(saved));
      }
    }
  }

  // remove compare blocks
  $('div.remove > a').on('click', function (e) {
    e.preventDefault();
    var saveType = $(this).data('savetype');
    var saveId = $(this).data('saveid');
    var arrayName;

    if (saveType === 'comm') {
      arrayName = 'saveCompareCommunities';
    } else if (saveType === 'qmi') {
      arrayName = 'saveCompareHomes';
    } else if (saveType === 'floor') {
      arrayName = 'saveCompareFloor';
    }

    removeCompare(arrayName, saveId);
    $(this).closest('.compare-container').parent().fadeOut(500, function () {
      $(this).remove();
    });
  });
});